module.exports = __webpack_public_path__ + "static/media/content-02.ca7c9d2a.png";